// export this package's api
module.exports = require('./Upload');



// WEBPACK FOOTER //
// ./_rc-upload-2.2.0/src/index.js